import React from 'react';
import { GetStaticProps } from 'next';
import { bffService, Spacer, Wrapper } from '@thisisdevelopment/akzonobel-core';
import { CmsSections, CmsSectionType } from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { useTheme } from 'styled-components';
import { Section } from '../../../src/components/Section';
import { CmsBanner } from '../../../src/components/CmsBanner';
import { pageRevalidate } from '../../../src/config';

type FeaturesType = {
  slug: string;
  banner: number;
  banner_title: string;
  banner_text: string;
  cta_label: string;
  cta_link: string;
  cta_text: string;
  cta_title: string;
  sections: CmsSectionType[];
  footer_title: string;
  footer_sections: CmsSectionType[];
};

type SSRProps = {
  page: FeaturesType;
};

function Features({ page }: SSRProps) {
  const meta = metas.default;
  const theme = useTheme();

  return (
    <div>
      <NextHead meta={meta} />
      <Wrapper as="main" bgColor={theme.colors.white}>
        {page && (
          <>
            <CmsBanner
              imageId={page.banner}
              headline={page.banner_text}
              title={page.banner_title}
            />
            <Section
              title={page.cta_title}
              text={page.cta_text}
              linkLabel={page.cta_label}
              url={page.cta_link}
            />
            <CmsSections sections={page.sections} />
            <Section title={page.footer_title} />
            <CmsSections sections={page.footer_sections} />
            <Spacer mt="40px" />
          </>
        )}
      </Wrapper>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const page = await bffService
    .getCmsItemBySlug('features', params?.slug as string)
    .then((r) => r.data.data);
  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export async function getStaticPaths() {
  const pages = await bffService.getCmsItem('features').then((r) => r.data.data);
  const paths = pages.map((p: FeaturesType) => ({
    params: { slug: p.slug },
  }));
  return {
    paths,
    fallback: false,
  };
}

export default Features;
